<template>
  <router-view></router-view>
</template>
<script type="text/javascript">
export default {
  name: 'LifePolicy'
}

</script>



// WEBPACK FOOTER //
// src/Osm/LifePolicy/containers/LifePolicy.vue